/**
 * Turns three measurements into a WhatsApp enquiry.
 *
 * No price, by design: custom sizes are quoted by a person, and the reference
 * site's pricing matrix is deliberately not ported. The link is built on click
 * rather than kept in sync on every keystroke, because it is only ever needed
 * once and the fields are the source of truth until then.
 */
class CustomSize extends HTMLElement {
  connectedCallback() {
    this.submit = this.querySelector('[data-cs-submit]');
    this.error = this.querySelector('[data-cs-error]');
    if (!this.submit) return;

    this.onSubmit = this.onSubmit.bind(this);
    this.submit.addEventListener('click', this.onSubmit);
  }

  disconnectedCallback() {
    this.submit?.removeEventListener('click', this.onSubmit);
  }

  value(name) {
    const field = this.querySelector(`[data-cs-${name}]`);
    return field ? field.value.trim() : '';
  }

  onSubmit(event) {
    event.preventDefault();

    const length = this.value('length');
    const breadth = this.value('breadth');
    const thickness = this.value('thickness');

    // A quote for two of three dimensions is a quote for nothing.
    if (!length || !breadth || !thickness) {
      if (this.error) this.error.hidden = false;
      return;
    }
    if (this.error) this.error.hidden = true;

    const unit = this.value('unit') || 'in';
    const size = `${length} × ${breadth} × ${thickness} ${unit}`;

    const message = (this.dataset.template || '')
      .replace('[product]', this.dataset.title || '')
      .replace('[size]', size)
      .replace('[url]', this.dataset.url || '');

    // Only the message is encoded. Encoding the whole URL would escape the
    // query separator and hand WhatsApp one long unreadable path.
    const number = (this.dataset.number || '').replace(/\D/g, '');
    window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
  }
}

customElements.define('custom-size', CustomSize);
